/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
    readonly action: PortfolioItemsAction;
    readonly endPortfolioItemId?: string | null;
    readonly itemsIds?: ReadonlyArray<string | null> | null;
    readonly note?: string | null;
    readonly portfolioItemsIds?: ReadonlyArray<string | null> | null;
    readonly portfolioId?: string | null;
    readonly portfolioType?: PortfolioType | null;
    readonly startPortfolioItemId?: string | null;
    readonly targetPortfolioItemId?: string | null;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type FindingSharedModifyPortfolioItemsMutationVariables = {
    readonly input: ModifyPortfolioItemsInput;
};
export type FindingSharedModifyPortfolioItemsMutationResponse = {
    readonly modifyPortfolioItems: {
        readonly removedItemIds: ReadonlyArray<string | null> | null;
    } | null;
};
export type FindingSharedModifyPortfolioItemsMutation = {
    readonly response: FindingSharedModifyPortfolioItemsMutationResponse;
    readonly variables: FindingSharedModifyPortfolioItemsMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ModifyPortfolioItemsInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "modifyPortfolioItems",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ModifyPortfolioItemsPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "removedItemIds",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "FindingSharedModifyPortfolioItemsMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "FindingSharedModifyPortfolioItemsMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "FindingSharedModifyPortfolioItemsMutation",
            "id": "app-buyer-finding/233.0.0-2019-09-19T10:07:06.974Z/FindingSharedModifyPortfolioItemsMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '3686fb0a0421042f6ec588dd6f81f363';
export default node;
